"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API Documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseViewBlockKindEnum = exports.DatabaseListViewConfigKindEnum = exports.DatabaseBlockViewEnum = exports.DatabaseBlockKindEnum = exports.CreateSuggestionToolInvocationStateEnum = exports.CreateSuggestionToolInvocationToolNameEnum = exports.CreateDocumentToolInvocationStateEnum = exports.CreateDocumentToolInvocationToolNameEnum = exports.ContextTemplateKindEnum = exports.ContextTaskDefinitionKindEnum = exports.ContextSolutionKindEnum = exports.ContextSelectionKindEnum = exports.ContextResourceDataNamespaceEnum = exports.ContextResourceKindEnum = exports.ContextPromptKindEnum = exports.ContextItemOneOf2KindEnum = exports.ContextItemOneOf1KindEnum = exports.ContextItemOneOfKindEnum = exports.ContextIntegrationKindEnum = exports.ContextFormKindEnum = exports.ContextFileDataTypeEnum = exports.ContextFileKindEnum = exports.ContextDocumentReferenceKindEnum = exports.ContextCollectionKindEnum = exports.CodeBlockKindEnum = exports.ChatListMessagesResponseObjectEnum = exports.CalloutBlockKindEnum = exports.ButtonWebhookActionTypeEnum = exports.ButtonLLMActionTypeEnum = exports.ButtonBlockKindEnum = exports.BlockObjectEnum = exports.AssistantSuggestionPositionOneOf2KindEnum = exports.AssistantSuggestionPositionOneOf1KindEnum = exports.AssistantSuggestionPositionOneOfKindEnum = exports.AssistantSuggestionOperationOneOfKindEnum = exports.AssistantSuggestionOperationDeleteKindEnum = exports.AssistantSuggestionOperationCreateKindEnum = exports.AssistantRuntimePromptTag = exports.AssistantRuntimeMode = exports.AssistantRuntimeEnvironment = exports.AssistantRequirementStatusStatus = exports.AssistantBlockCreateRequestTextKindEnum = exports.AssistantBlockCreateRequestListItemStyleEnum = exports.AssistantBlockCreateRequestListItemKindEnum = exports.AssistantBlockCreateRequestCalloutKindEnum = exports.AssistantArtifactOneOfKindEnum = exports.ApplySuggestionToolInvocationStateEnum = exports.ApplySuggestionToolInvocationToolNameEnum = exports.AgentList200ResponseObjectEnum = exports.AgentObjectEnum = void 0;
exports.SearchToolInvocationToolNameEnum = exports.ResourceBlockKindEnum = exports.ReplacementDocumentToolInvocationStateEnum = exports.ReplacementDocumentToolInvocationToolNameEnum = exports.ReferenceSpanKindEnum = exports.ReadSnippetToolInvocationStateEnum = exports.ReadSnippetToolInvocationToolNameEnum = exports.ReadFormToolInvocationOutputFormConfigAccessLevelEnum = exports.ReadFormToolInvocationStateEnum = exports.ReadFormToolInvocationToolNameEnum = exports.ReadDocumentToolInvocationStateEnum = exports.ReadDocumentToolInvocationToolNameEnum = exports.ReadCollectionToolInvocationOutputStatusEnum = exports.ReadCollectionToolInvocationStateEnum = exports.ReadCollectionToolInvocationToolNameEnum = exports.ReadBlockToolInvocationStateEnum = exports.ReadBlockToolInvocationToolNameEnum = exports.QuoteBlockKindEnum = exports.PageFootnoteItemKindEnum = exports.MessageStepStartTypeEnum = exports.MessageStepEndTypeEnum = exports.MessageRole = exports.MessagePartToolTypeEnum = exports.MessagePartTextTypeEnum = exports.MentionUserConfigTypeEnum = exports.MentionSpanKindEnum = exports.MentionPageConfigTypeEnum = exports.ListItemBlockStyleEnum = exports.ListItemBlockKindEnum = exports.ListDocumentsToolInvocationStateEnum = exports.ListDocumentsToolInvocationToolNameEnum = exports.ListCollectionDocumentsToolInvocationStateEnum = exports.ListCollectionDocumentsToolInvocationToolNameEnum = exports.HeadingBlockKindEnum = exports.GetTaskToolInvocationArgsContentTypeEnum = exports.GetTaskToolInvocationStateEnum = exports.GetTaskToolInvocationToolNameEnum = exports.GetStatusToolInvocationStateEnum = exports.GetStatusToolInvocationToolNameEnum = exports.GetStatsToolInvocationStateEnum = exports.GetStatsToolInvocationToolNameEnum = exports.GetAssistantTaskToolInvocationStateEnum = exports.GetAssistantTaskToolInvocationToolNameEnum = exports.FormBlockKindEnum = exports.FootnoteBlockKindEnum = exports.ExternalFootnoteItemKindEnum = exports.DividerBlockKindEnum = exports.DetermineWorkflowToolInvocationOutputWorkflowIdEnum = exports.DetermineWorkflowToolInvocationStateEnum = exports.DetermineWorkflowToolInvocationToolNameEnum = void 0;
exports.UpdateThreadToolInvocationToolNameEnum = exports.ThreadListResponseObjectEnum = exports.ThreadContextTemplateItemKindEnum = exports.ThreadContextTaskItemKindEnum = exports.ThreadContextSolutionItemKindEnum = exports.ThreadContextSelectionItemKindEnum = exports.ThreadContextRootItemKindEnum = exports.ThreadContextResourceItemNamespaceEnum = exports.ThreadContextResourceItemKindEnum = exports.ThreadContextPromptItemKindEnum = exports.ThreadContextIntegrationItemKindEnum = exports.ThreadContextFormItemKindEnum = exports.ThreadContextFileItemTypeEnum = exports.ThreadContextFileItemKindEnum = exports.ThreadContextDocumentItemKindEnum = exports.ThreadContextCollectionItemKindEnum = exports.ThreadObjectEnum = exports.TextSpanKindEnum = exports.TextBlockKindEnum = exports.TaskStatus = exports.TaskList200ResponseObjectEnum = exports.TaskCreateReportSchemaKindEnum = exports.TaskBlockKindEnum = exports.TaskAskAnalysisSchemaInputContentOneOf2KindEnum = exports.TaskAskAnalysisSchemaInputContentOneOf1KindEnum = exports.TaskAskAnalysisSchemaInputContentOneOfKindEnum = exports.TaskAskAnalysisSchemaKindEnum = exports.TaskObjectEnum = exports.SuggestionTextBlockKindEnum = exports.SuggestionListItemBlockStyleEnum = exports.SuggestionListItemBlockKindEnum = exports.SuggestionCalloutBlockKindEnum = exports.StartWorkflowToolInvocationStateEnum = exports.StartWorkflowToolInvocationToolNameEnum = exports.StartSolutionToolInvocationStateEnum = exports.StartSolutionToolInvocationToolNameEnum = exports.StartSolutionDocumentArtifactKindEnum = exports.StartCallToolInvocationOutputStatusOneOf2KindEnum = exports.StartCallToolInvocationOutputStatusOneOf1KindEnum = exports.StartCallToolInvocationOutputStatusOneOfKindEnum = exports.StartCallToolInvocationArgsTranscriptMessagesInnerRoleEnum = exports.StartCallToolInvocationStateEnum = exports.StartCallToolInvocationToolNameEnum = exports.StartAssistantTaskToolInvocationStateEnum = exports.StartAssistantTaskToolInvocationToolNameEnum = exports.SessionType = exports.SessionObjectObjectEnum = exports.SearchToolInvocationOutputResultsInnerReferencesInnerRelationEnum = exports.SearchToolInvocationArgsObjectTypesEnum = exports.SearchToolInvocationStateEnum = void 0;
exports.SystemApi = exports.SystemApiFactory = exports.SystemApiFp = exports.SystemApiAxiosParamCreator = exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.UpdateThreadToolInvocationStateEnum = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("./common");
// @ts-ignore
const base_1 = require("./base");
exports.AgentObjectEnum = {
    Agent: 'agent'
};
exports.AgentList200ResponseObjectEnum = {
    List: 'list'
};
exports.ApplySuggestionToolInvocationToolNameEnum = {
    ApplySuggestion: 'apply_suggestion'
};
exports.ApplySuggestionToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.AssistantArtifactOneOfKindEnum = {
    Document: 'document'
};
exports.AssistantBlockCreateRequestCalloutKindEnum = {
    Callout: 'callout'
};
exports.AssistantBlockCreateRequestListItemKindEnum = {
    ListItem: 'list_item'
};
exports.AssistantBlockCreateRequestListItemStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.AssistantBlockCreateRequestTextKindEnum = {
    Text: 'text'
};
/**
 * The status of the requirement
 * @export
 * @enum {string}
 */
exports.AssistantRequirementStatusStatus = {
    Pending: 'pending',
    Completed: 'completed'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AssistantRuntimeEnvironment = {
    Live: 'live',
    Test: 'test'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AssistantRuntimeMode = {
    Workspace: 'workspace',
    Ask: 'ask',
    Solution: 'solution'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.AssistantRuntimePromptTag = {
    Active: 'active',
    Latest: 'latest',
    Preview: 'preview',
    Develop: 'develop'
};
exports.AssistantSuggestionOperationCreateKindEnum = {
    Create: 'create'
};
exports.AssistantSuggestionOperationDeleteKindEnum = {
    Delete: 'delete'
};
exports.AssistantSuggestionOperationOneOfKindEnum = {
    Update: 'update'
};
exports.AssistantSuggestionPositionOneOfKindEnum = {
    Append: 'append'
};
exports.AssistantSuggestionPositionOneOf1KindEnum = {
    Before: 'before'
};
exports.AssistantSuggestionPositionOneOf2KindEnum = {
    After: 'after'
};
exports.BlockObjectEnum = {
    Block: 'block'
};
exports.ButtonBlockKindEnum = {
    Button: 'button'
};
exports.ButtonLLMActionTypeEnum = {
    Llm: 'llm'
};
exports.ButtonWebhookActionTypeEnum = {
    Webhook: 'webhook'
};
exports.CalloutBlockKindEnum = {
    Callout: 'callout'
};
exports.ChatListMessagesResponseObjectEnum = {
    List: 'list'
};
exports.CodeBlockKindEnum = {
    Code: 'code'
};
exports.ContextCollectionKindEnum = {
    Collection: 'collection'
};
exports.ContextDocumentReferenceKindEnum = {
    Reference: 'reference'
};
exports.ContextFileKindEnum = {
    File: 'file'
};
exports.ContextFileDataTypeEnum = {
    Csv: 'csv',
    Markdown: 'markdown'
};
exports.ContextFormKindEnum = {
    Form: 'form'
};
exports.ContextIntegrationKindEnum = {
    Integration: 'integration'
};
exports.ContextItemOneOfKindEnum = {
    Editing: 'editing'
};
exports.ContextItemOneOf1KindEnum = {
    Thread: 'thread'
};
exports.ContextItemOneOf2KindEnum = {
    Root: 'root'
};
exports.ContextPromptKindEnum = {
    Prompt: 'prompt'
};
exports.ContextResourceKindEnum = {
    Resource: 'resource'
};
exports.ContextResourceDataNamespaceEnum = {
    Knowledge: 'knowledge'
};
exports.ContextSelectionKindEnum = {
    Selection: 'selection'
};
exports.ContextSolutionKindEnum = {
    Solution: 'solution'
};
exports.ContextTaskDefinitionKindEnum = {
    Task: 'task'
};
exports.ContextTemplateKindEnum = {
    Template: 'template'
};
exports.CreateDocumentToolInvocationToolNameEnum = {
    CreateDocument: 'create_document'
};
exports.CreateDocumentToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.CreateSuggestionToolInvocationToolNameEnum = {
    CreateSuggestion: 'create_suggestion'
};
exports.CreateSuggestionToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.DatabaseBlockKindEnum = {
    Database: 'database'
};
exports.DatabaseBlockViewEnum = {
    Table: 'table',
    List: 'list'
};
exports.DatabaseListViewConfigKindEnum = {
    List: 'list'
};
exports.DatabaseViewBlockKindEnum = {
    DatabaseView: 'database_view'
};
exports.DetermineWorkflowToolInvocationToolNameEnum = {
    DetermineWorkflow: 'determine_workflow'
};
exports.DetermineWorkflowToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.DetermineWorkflowToolInvocationOutputWorkflowIdEnum = {
    Report: 'report',
    VendorComparison: 'vendor_comparison'
};
exports.DividerBlockKindEnum = {
    Divider: 'divider'
};
exports.ExternalFootnoteItemKindEnum = {
    External: 'external'
};
exports.FootnoteBlockKindEnum = {
    Footnote: 'footnote'
};
exports.FormBlockKindEnum = {
    Form: 'form'
};
exports.GetAssistantTaskToolInvocationToolNameEnum = {
    GetAssistantTask: 'get_assistant_task'
};
exports.GetAssistantTaskToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.GetStatsToolInvocationToolNameEnum = {
    GetDocumentsStats: 'get_documents_stats'
};
exports.GetStatsToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.GetStatusToolInvocationToolNameEnum = {
    GetTaskStatus: 'get_task_status'
};
exports.GetStatusToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.GetTaskToolInvocationToolNameEnum = {
    GetTaskDescription: 'get_task_description'
};
exports.GetTaskToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.GetTaskToolInvocationArgsContentTypeEnum = {
    Report: 'report',
    VendorComparison: 'vendor_comparison'
};
exports.HeadingBlockKindEnum = {
    Heading: 'heading'
};
exports.ListCollectionDocumentsToolInvocationToolNameEnum = {
    ListCollectionDocuments: 'list_collection_documents'
};
exports.ListCollectionDocumentsToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ListDocumentsToolInvocationToolNameEnum = {
    ListDocuments: 'list_documents'
};
exports.ListDocumentsToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ListItemBlockKindEnum = {
    ListItem: 'list_item'
};
exports.ListItemBlockStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.MentionPageConfigTypeEnum = {
    Page: 'page'
};
exports.MentionSpanKindEnum = {
    Mention: 'mention'
};
exports.MentionUserConfigTypeEnum = {
    User: 'user'
};
exports.MessagePartTextTypeEnum = {
    Text: 'text'
};
exports.MessagePartToolTypeEnum = {
    ToolInvocation: 'tool-invocation'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.MessageRole = {
    User: 'user',
    Assistant: 'assistant',
    System: 'system',
    Data: 'data'
};
exports.MessageStepEndTypeEnum = {
    StepEnd: 'step-end'
};
exports.MessageStepStartTypeEnum = {
    StepStart: 'step-start'
};
exports.PageFootnoteItemKindEnum = {
    Page: 'page'
};
exports.QuoteBlockKindEnum = {
    Quote: 'quote'
};
exports.ReadBlockToolInvocationToolNameEnum = {
    ReadBlock: 'read_block'
};
exports.ReadBlockToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ReadCollectionToolInvocationToolNameEnum = {
    ReadCollection: 'read_collection'
};
exports.ReadCollectionToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ReadCollectionToolInvocationOutputStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
};
exports.ReadDocumentToolInvocationToolNameEnum = {
    ReadDocument: 'read_document'
};
exports.ReadDocumentToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ReadFormToolInvocationToolNameEnum = {
    ReadForm: 'read_form'
};
exports.ReadFormToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ReadFormToolInvocationOutputFormConfigAccessLevelEnum = {
    Workspace: 'workspace',
    Public: 'public',
    Private: 'private'
};
exports.ReadSnippetToolInvocationToolNameEnum = {
    ReadSnippet: 'read_snippet'
};
exports.ReadSnippetToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ReferenceSpanKindEnum = {
    Reference: 'reference'
};
exports.ReplacementDocumentToolInvocationToolNameEnum = {
    ReplaceDocument: 'replace_document'
};
exports.ReplacementDocumentToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.ResourceBlockKindEnum = {
    Resource: 'resource'
};
exports.SearchToolInvocationToolNameEnum = {
    Search: 'search'
};
exports.SearchToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.SearchToolInvocationArgsObjectTypesEnum = {
    Document: 'document',
    Form: 'form',
    Collection: 'collection',
    Snippet: 'snippet',
    Block: 'block'
};
exports.SearchToolInvocationOutputResultsInnerReferencesInnerRelationEnum = {
    ContainedIn: 'is_contained_in',
    AncestorOf: 'is_ancestor_of',
    DescendantOf: 'is_descendant_of',
    SiblingOf: 'is_sibling_of'
};
exports.SessionObjectObjectEnum = {
    Session: 'session'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.SessionType = {
    Realtime: 'realtime'
};
exports.StartAssistantTaskToolInvocationToolNameEnum = {
    StartAssistantTask: 'start_assistant_task'
};
exports.StartAssistantTaskToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.StartCallToolInvocationToolNameEnum = {
    StartCall: 'start_call'
};
exports.StartCallToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.StartCallToolInvocationArgsTranscriptMessagesInnerRoleEnum = {
    User: 'user',
    Assistant: 'assistant',
    System: 'system'
};
exports.StartCallToolInvocationOutputStatusOneOfKindEnum = {
    Finished: 'finished'
};
exports.StartCallToolInvocationOutputStatusOneOf1KindEnum = {
    Rejected: 'rejected'
};
exports.StartCallToolInvocationOutputStatusOneOf2KindEnum = {
    Timeout: 'timeout'
};
exports.StartSolutionDocumentArtifactKindEnum = {
    Document: 'document'
};
exports.StartSolutionToolInvocationToolNameEnum = {
    StartSolution: 'start_solution'
};
exports.StartSolutionToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.StartWorkflowToolInvocationToolNameEnum = {
    StartWorkflow: 'start_workflow'
};
exports.StartWorkflowToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
exports.SuggestionCalloutBlockKindEnum = {
    Callout: 'callout'
};
exports.SuggestionListItemBlockKindEnum = {
    ListItem: 'list_item'
};
exports.SuggestionListItemBlockStyleEnum = {
    Bullet: 'bullet',
    Number: 'number'
};
exports.SuggestionTextBlockKindEnum = {
    Text: 'text'
};
exports.TaskObjectEnum = {
    Task: 'task'
};
exports.TaskAskAnalysisSchemaKindEnum = {
    AskAnalysis: 'ask-analysis'
};
exports.TaskAskAnalysisSchemaInputContentOneOfKindEnum = {
    RootDocument: 'root-document'
};
exports.TaskAskAnalysisSchemaInputContentOneOf1KindEnum = {
    SpecificDocuments: 'specific-documents'
};
exports.TaskAskAnalysisSchemaInputContentOneOf2KindEnum = {
    Collection: 'collection'
};
exports.TaskBlockKindEnum = {
    Task: 'task'
};
exports.TaskCreateReportSchemaKindEnum = {
    Report: 'report'
};
exports.TaskList200ResponseObjectEnum = {
    List: 'list'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.TaskStatus = {
    Pending: 'pending',
    Running: 'running',
    Completed: 'completed',
    Failed: 'failed'
};
exports.TextBlockKindEnum = {
    Text: 'text'
};
exports.TextSpanKindEnum = {
    Text: 'text'
};
exports.ThreadObjectEnum = {
    Thread: 'thread'
};
exports.ThreadContextCollectionItemKindEnum = {
    Collection: 'collection'
};
exports.ThreadContextDocumentItemKindEnum = {
    Reference: 'reference'
};
exports.ThreadContextFileItemKindEnum = {
    File: 'file'
};
exports.ThreadContextFileItemTypeEnum = {
    Csv: 'csv',
    Markdown: 'markdown'
};
exports.ThreadContextFormItemKindEnum = {
    Form: 'form'
};
exports.ThreadContextIntegrationItemKindEnum = {
    Integration: 'integration'
};
exports.ThreadContextPromptItemKindEnum = {
    Prompt: 'prompt'
};
exports.ThreadContextResourceItemKindEnum = {
    Resource: 'resource'
};
exports.ThreadContextResourceItemNamespaceEnum = {
    Knowledge: 'knowledge'
};
exports.ThreadContextRootItemKindEnum = {
    Root: 'root'
};
exports.ThreadContextSelectionItemKindEnum = {
    Selection: 'selection'
};
exports.ThreadContextSolutionItemKindEnum = {
    Solution: 'solution'
};
exports.ThreadContextTaskItemKindEnum = {
    Task: 'task'
};
exports.ThreadContextTemplateItemKindEnum = {
    Template: 'template'
};
exports.ThreadListResponseObjectEnum = {
    List: 'list'
};
exports.UpdateThreadToolInvocationToolNameEnum = {
    UpdateThread: 'update_thread'
};
exports.UpdateThreadToolInvocationStateEnum = {
    Call: 'call',
    Result: 'result'
};
/**
 * DefaultApi - axios parameter creator
 * @export
 */
const DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary agent create
         * @param {string} [xWorkspaceId]
         * @param {AgentCreatePayload} [agentCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentCreate: async (xWorkspaceId, agentCreatePayload, options = {}) => {
            const localVarPath = `/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(agentCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary agent list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/agents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary agent retrieve
         * @param {string} agentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentRetrieve: async (agentId, xWorkspaceId, options = {}) => {
            // verify required parameter 'agentId' is not null or undefined
            (0, common_1.assertParamExists)('agentRetrieve', 'agentId', agentId);
            const localVarPath = `/agents/{agentId}`
                .replace(`{${"agentId"}}`, encodeURIComponent(String(agentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary chat create
         * @param {string} [xWorkspaceId]
         * @param {ChatCreateRequest} [chatCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCreate: async (xWorkspaceId, chatCreateRequest, options = {}) => {
            const localVarPath = `/chat`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chatCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary chat generate
         * @param {string} [xWorkspaceId]
         * @param {ChatGenerateMessageRequest} [chatGenerateMessageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatGenerate: async (xWorkspaceId, chatGenerateMessageRequest, options = {}) => {
            const localVarPath = `/chat/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(chatGenerateMessageRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary message list
         * @param {string} thread The thread ID to list messages for
         * @param {string} [after] The cursor token to start listing messages from
         * @param {number} [limit] The maximum number of threads to list
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList: async (thread, after, limit, xWorkspaceId, options = {}) => {
            // verify required parameter 'thread' is not null or undefined
            (0, common_1.assertParamExists)('messageList', 'thread', thread);
            const localVarPath = `/chat/messages`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (thread !== undefined) {
                localVarQueryParameter['thread'] = thread;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary session create
         * @param {string} [xWorkspaceId]
         * @param {SessionCreatePayload} [sessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate: async (xWorkspaceId, sessionCreatePayload, options = {}) => {
            const localVarPath = `/sessions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(sessionCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary signal create
         * @param {string} [xWorkspaceId]
         * @param {SignalCreatePayload} [signalCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signalCreate: async (xWorkspaceId, signalCreatePayload, options = {}) => {
            const localVarPath = `/signals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(signalCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task create
         * @param {string} [xWorkspaceId]
         * @param {TaskCreatePayload} [taskCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskCreate: async (xWorkspaceId, taskCreatePayload, options = {}) => {
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(taskCreatePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskList: async (limit, xWorkspaceId, options = {}) => {
            const localVarPath = `/tasks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary task retrieve
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRetrieve: async (taskId, xWorkspaceId, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('taskRetrieve', 'taskId', taskId);
            const localVarPath = `/tasks/{taskId}`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread create
         * @param {string} [xWorkspaceId]
         * @param {ThreadCreateRequest} [threadCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate: async (xWorkspaceId, threadCreateRequest, options = {}) => {
            const localVarPath = `/chat/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadCreateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread generate
         * @param {string} [xWorkspaceId]
         * @param {ThreadGenerateRequest} [threadGenerateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadGenerate: async (xWorkspaceId, threadGenerateRequest, options = {}) => {
            const localVarPath = `/chat/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadGenerateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread list
         * @param {number} [limit] The maximum number of threads to list
         * @param {string} [after] The cursor token for pagination
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadList: async (limit, after, xWorkspaceId, options = {}) => {
            const localVarPath = `/chat/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve: async (threadId, xWorkspaceId, options = {}) => {
            // verify required parameter 'threadId' is not null or undefined
            (0, common_1.assertParamExists)('threadRetrieve', 'threadId', threadId);
            const localVarPath = `/chat/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary thread update
         * @param {string} threadId
         * @param {string} [xWorkspaceId]
         * @param {ThreadUpdateRequest} [threadUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadUpdate: async (threadId, xWorkspaceId, threadUpdateRequest, options = {}) => {
            // verify required parameter 'threadId' is not null or undefined
            (0, common_1.assertParamExists)('threadUpdate', 'threadId', threadId);
            const localVarPath = `/chat/threads/{threadId}`
                .replace(`{${"threadId"}}`, encodeURIComponent(String(threadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(threadUpdateRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary turn_credentials retrieve
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        turnCredentialsRetrieve: async (xWorkspaceId, options = {}) => {
            const localVarPath = `/turn/credentials`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
/**
 * DefaultApi - functional programming interface
 * @export
 */
const DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary agent create
         * @param {string} [xWorkspaceId]
         * @param {AgentCreatePayload} [agentCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentCreate(xWorkspaceId, agentCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentCreate(xWorkspaceId, agentCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.agentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary agent list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.agentList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary agent retrieve
         * @param {string} agentId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agentRetrieve(agentId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agentRetrieve(agentId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.agentRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary chat create
         * @param {string} [xWorkspaceId]
         * @param {ChatCreateRequest} [chatCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatCreate(xWorkspaceId, chatCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatCreate(xWorkspaceId, chatCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.chatCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary chat generate
         * @param {string} [xWorkspaceId]
         * @param {ChatGenerateMessageRequest} [chatGenerateMessageRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async chatGenerate(xWorkspaceId, chatGenerateMessageRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.chatGenerate(xWorkspaceId, chatGenerateMessageRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.chatGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary message list
         * @param {string} thread The thread ID to list messages for
         * @param {string} [after] The cursor token to start listing messages from
         * @param {number} [limit] The maximum number of threads to list
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageList(thread, after, limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageList(thread, after, limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.messageList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary session create
         * @param {string} [xWorkspaceId]
         * @param {SessionCreatePayload} [sessionCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sessionCreate(xWorkspaceId, sessionCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sessionCreate(xWorkspaceId, sessionCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.sessionCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary signal create
         * @param {string} [xWorkspaceId]
         * @param {SignalCreatePayload} [signalCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async signalCreate(xWorkspaceId, signalCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.signalCreate(xWorkspaceId, signalCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.signalCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task create
         * @param {string} [xWorkspaceId]
         * @param {TaskCreatePayload} [taskCreatePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskCreate(xWorkspaceId, taskCreatePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskCreate(xWorkspaceId, taskCreatePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task list
         * @param {number} [limit]
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskList(limit, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskList(limit, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary task retrieve
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async taskRetrieve(taskId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.taskRetrieve(taskId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.taskRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread create
         * @param {string} [xWorkspaceId]
         * @param {ThreadCreateRequest} [threadCreateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadCreate(xWorkspaceId, threadCreateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadCreate(xWorkspaceId, threadCreateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread generate
         * @param {string} [xWorkspaceId]
         * @param {ThreadGenerateRequest} [threadGenerateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadGenerate(xWorkspaceId, threadGenerateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadGenerate(xWorkspaceId, threadGenerateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadGenerate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread list
         * @param {number} [limit] The maximum number of threads to list
         * @param {string} [after] The cursor token for pagination
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadList(limit, after, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadList(limit, after, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread retrieve
         * @param {string} threadId
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadRetrieve(threadId, xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadRetrieve(threadId, xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary thread update
         * @param {string} threadId
         * @param {string} [xWorkspaceId]
         * @param {ThreadUpdateRequest} [threadUpdateRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async threadUpdate(threadId, xWorkspaceId, threadUpdateRequest, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.threadUpdate(threadId, xWorkspaceId, threadUpdateRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.threadUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary turn_credentials retrieve
         * @param {string} [xWorkspaceId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async turnCredentialsRetrieve(xWorkspaceId, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.turnCredentialsRetrieve(xWorkspaceId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['DefaultApi.turnCredentialsRetrieve']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
/**
 * DefaultApi - factory interface
 * @export
 */
const DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        /**
         *
         * @summary agent create
         * @param {DefaultApiAgentCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentCreate(requestParameters = {}, options) {
            return localVarFp.agentCreate(requestParameters.xWorkspaceId, requestParameters.agentCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary agent list
         * @param {DefaultApiAgentListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentList(requestParameters = {}, options) {
            return localVarFp.agentList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary agent retrieve
         * @param {DefaultApiAgentRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agentRetrieve(requestParameters, options) {
            return localVarFp.agentRetrieve(requestParameters.agentId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary chat create
         * @param {DefaultApiChatCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatCreate(requestParameters = {}, options) {
            return localVarFp.chatCreate(requestParameters.xWorkspaceId, requestParameters.chatCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary chat generate
         * @param {DefaultApiChatGenerateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        chatGenerate(requestParameters = {}, options) {
            return localVarFp.chatGenerate(requestParameters.xWorkspaceId, requestParameters.chatGenerateMessageRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary message list
         * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageList(requestParameters, options) {
            return localVarFp.messageList(requestParameters.thread, requestParameters.after, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary session create
         * @param {DefaultApiSessionCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sessionCreate(requestParameters = {}, options) {
            return localVarFp.sessionCreate(requestParameters.xWorkspaceId, requestParameters.sessionCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary signal create
         * @param {DefaultApiSignalCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        signalCreate(requestParameters = {}, options) {
            return localVarFp.signalCreate(requestParameters.xWorkspaceId, requestParameters.signalCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task create
         * @param {DefaultApiTaskCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskCreate(requestParameters = {}, options) {
            return localVarFp.taskCreate(requestParameters.xWorkspaceId, requestParameters.taskCreatePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task list
         * @param {DefaultApiTaskListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskList(requestParameters = {}, options) {
            return localVarFp.taskList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary task retrieve
         * @param {DefaultApiTaskRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        taskRetrieve(requestParameters, options) {
            return localVarFp.taskRetrieve(requestParameters.taskId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread create
         * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadCreate(requestParameters = {}, options) {
            return localVarFp.threadCreate(requestParameters.xWorkspaceId, requestParameters.threadCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread generate
         * @param {DefaultApiThreadGenerateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadGenerate(requestParameters = {}, options) {
            return localVarFp.threadGenerate(requestParameters.xWorkspaceId, requestParameters.threadGenerateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread list
         * @param {DefaultApiThreadListRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadList(requestParameters = {}, options) {
            return localVarFp.threadList(requestParameters.limit, requestParameters.after, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread retrieve
         * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadRetrieve(requestParameters, options) {
            return localVarFp.threadRetrieve(requestParameters.threadId, requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary thread update
         * @param {DefaultApiThreadUpdateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        threadUpdate(requestParameters, options) {
            return localVarFp.threadUpdate(requestParameters.threadId, requestParameters.xWorkspaceId, requestParameters.threadUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary turn_credentials retrieve
         * @param {DefaultApiTurnCredentialsRetrieveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        turnCredentialsRetrieve(requestParameters = {}, options) {
            return localVarFp.turnCredentialsRetrieve(requestParameters.xWorkspaceId, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     *
     * @summary agent create
     * @param {DefaultApiAgentCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    agentCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).agentCreate(requestParameters.xWorkspaceId, requestParameters.agentCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary agent list
     * @param {DefaultApiAgentListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    agentList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).agentList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary agent retrieve
     * @param {DefaultApiAgentRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    agentRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).agentRetrieve(requestParameters.agentId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary chat create
     * @param {DefaultApiChatCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    chatCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).chatCreate(requestParameters.xWorkspaceId, requestParameters.chatCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary chat generate
     * @param {DefaultApiChatGenerateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    chatGenerate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).chatGenerate(requestParameters.xWorkspaceId, requestParameters.chatGenerateMessageRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary message list
     * @param {DefaultApiMessageListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    messageList(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).messageList(requestParameters.thread, requestParameters.after, requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary session create
     * @param {DefaultApiSessionCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    sessionCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).sessionCreate(requestParameters.xWorkspaceId, requestParameters.sessionCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary signal create
     * @param {DefaultApiSignalCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    signalCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).signalCreate(requestParameters.xWorkspaceId, requestParameters.signalCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task create
     * @param {DefaultApiTaskCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskCreate(requestParameters.xWorkspaceId, requestParameters.taskCreatePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task list
     * @param {DefaultApiTaskListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskList(requestParameters.limit, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary task retrieve
     * @param {DefaultApiTaskRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    taskRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).taskRetrieve(requestParameters.taskId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread create
     * @param {DefaultApiThreadCreateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadCreate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadCreate(requestParameters.xWorkspaceId, requestParameters.threadCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread generate
     * @param {DefaultApiThreadGenerateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadGenerate(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadGenerate(requestParameters.xWorkspaceId, requestParameters.threadGenerateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread list
     * @param {DefaultApiThreadListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadList(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadList(requestParameters.limit, requestParameters.after, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread retrieve
     * @param {DefaultApiThreadRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadRetrieve(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadRetrieve(requestParameters.threadId, requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary thread update
     * @param {DefaultApiThreadUpdateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    threadUpdate(requestParameters, options) {
        return (0, exports.DefaultApiFp)(this.configuration).threadUpdate(requestParameters.threadId, requestParameters.xWorkspaceId, requestParameters.threadUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary turn_credentials retrieve
     * @param {DefaultApiTurnCredentialsRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    turnCredentialsRetrieve(requestParameters = {}, options) {
        return (0, exports.DefaultApiFp)(this.configuration).turnCredentialsRetrieve(requestParameters.xWorkspaceId, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
/**
 * SystemApi - axios parameter creator
 * @export
 */
const SystemApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary system task complete
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {SystemTaskCompletePayload} [systemTaskCompletePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskComplete: async (taskId, xWorkspaceId, systemTaskCompletePayload, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('systemTaskComplete', 'taskId', taskId);
            const localVarPath = `/system/tasks/{taskId}/complete`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(systemTaskCompletePayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary system task fail
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {SystemTaskFailPayload} [systemTaskFailPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskFail: async (taskId, xWorkspaceId, systemTaskFailPayload, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('systemTaskFail', 'taskId', taskId);
            const localVarPath = `/system/tasks/{taskId}/fail`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(systemTaskFailPayload, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary system task start
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskStart: async (taskId, xWorkspaceId, body, options = {}) => {
            // verify required parameter 'taskId' is not null or undefined
            (0, common_1.assertParamExists)('systemTaskStart', 'taskId', taskId);
            const localVarPath = `/system/tasks/{taskId}/start`
                .replace(`{${"taskId"}}`, encodeURIComponent(String(taskId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication BearerAuth required
            // http bearer authentication required
            await (0, common_1.setBearerAuthToObject)(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            if (xWorkspaceId != null) {
                localVarHeaderParameter['x-workspace-id'] = String(xWorkspaceId);
            }
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(body, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SystemApiAxiosParamCreator = SystemApiAxiosParamCreator;
/**
 * SystemApi - functional programming interface
 * @export
 */
const SystemApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.SystemApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary system task complete
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {SystemTaskCompletePayload} [systemTaskCompletePayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemTaskComplete(taskId, xWorkspaceId, systemTaskCompletePayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemTaskComplete(taskId, xWorkspaceId, systemTaskCompletePayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SystemApi.systemTaskComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary system task fail
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {SystemTaskFailPayload} [systemTaskFailPayload]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemTaskFail(taskId, xWorkspaceId, systemTaskFailPayload, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemTaskFail(taskId, xWorkspaceId, systemTaskFailPayload, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SystemApi.systemTaskFail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary system task start
         * @param {string} taskId
         * @param {string} [xWorkspaceId]
         * @param {object} [body]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemTaskStart(taskId, xWorkspaceId, body, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemTaskStart(taskId, xWorkspaceId, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = base_1.operationServerMap['SystemApi.systemTaskStart']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
exports.SystemApiFp = SystemApiFp;
/**
 * SystemApi - factory interface
 * @export
 */
const SystemApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.SystemApiFp)(configuration);
    return {
        /**
         *
         * @summary system task complete
         * @param {SystemApiSystemTaskCompleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskComplete(requestParameters, options) {
            return localVarFp.systemTaskComplete(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.systemTaskCompletePayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary system task fail
         * @param {SystemApiSystemTaskFailRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskFail(requestParameters, options) {
            return localVarFp.systemTaskFail(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.systemTaskFailPayload, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary system task start
         * @param {SystemApiSystemTaskStartRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemTaskStart(requestParameters, options) {
            return localVarFp.systemTaskStart(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.body, options).then((request) => request(axios, basePath));
        },
    };
};
exports.SystemApiFactory = SystemApiFactory;
/**
 * SystemApi - object-oriented interface
 * @export
 * @class SystemApi
 * @extends {BaseAPI}
 */
class SystemApi extends base_1.BaseAPI {
    /**
     *
     * @summary system task complete
     * @param {SystemApiSystemTaskCompleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    systemTaskComplete(requestParameters, options) {
        return (0, exports.SystemApiFp)(this.configuration).systemTaskComplete(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.systemTaskCompletePayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary system task fail
     * @param {SystemApiSystemTaskFailRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    systemTaskFail(requestParameters, options) {
        return (0, exports.SystemApiFp)(this.configuration).systemTaskFail(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.systemTaskFailPayload, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary system task start
     * @param {SystemApiSystemTaskStartRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemApi
     */
    systemTaskStart(requestParameters, options) {
        return (0, exports.SystemApiFp)(this.configuration).systemTaskStart(requestParameters.taskId, requestParameters.xWorkspaceId, requestParameters.body, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.SystemApi = SystemApi;
//# sourceMappingURL=api.js.map